import React, { FC } from 'react';

import * as Accordion from '@radix-ui/react-accordion';

import { CategoriesTree } from '@domains/categories';

import { makeCategoryRouteFromSource } from '@utils/category/category';

import { CategoryAccordionContent } from '@components/catalog/CategoryAccordion/CategoryAccordionContent';
import { Link } from '@components/common/Link/Link';

import styles from './CategoryAccordion.module.scss';

type CategoryAccordionProps = {
    categoriesTree: CategoriesTree;
};

export const CategoryAccordion: FC<CategoryAccordionProps> = (props) => {
    const { categoriesTree } = props;

    return (
        <Accordion.Root type="single" collapsible className={styles.accordionRoot}>
            {categoriesTree.map(({ slug, thumbnail, name, subcategories }) => (
                <Accordion.Item key={slug} value={slug} className={styles.accordionItem}>
                    <Accordion.Header asChild>
                        {subcategories.length > 0 ? (
                            <Accordion.Trigger className={styles.accordionHeader}>
                                <CategoryAccordionContent thumbnail={thumbnail} name={name} />
                            </Accordion.Trigger>
                        ) : (
                            <Link
                                route={makeCategoryRouteFromSource(slug, categoriesTree.source)}
                                className={styles.accordionHeader}
                            >
                                <CategoryAccordionContent thumbnail={thumbnail} name={name} />
                            </Link>
                        )}
                    </Accordion.Header>
                    {subcategories.length > 0 && (
                        <Accordion.Content asChild className={styles.accordionContent}>
                            <ul className={styles.subcategoryList}>
                                <li key={slug} className={styles.subcategoryListItem}>
                                    <Link
                                        route={makeCategoryRouteFromSource(
                                            slug,
                                            categoriesTree.source,
                                        )}
                                        className={styles.subcategoryLink}
                                    >
                                        Вся продукция
                                    </Link>
                                </li>
                                {subcategories.map(
                                    ({
                                        name: subcategoryTitle,
                                        id: subcategoryId,
                                        slug: subcategorySlug,
                                    }) => (
                                        <li
                                            key={subcategoryId}
                                            className={styles.subcategoryListItem}
                                        >
                                            <Link
                                                route={makeCategoryRouteFromSource(
                                                    subcategorySlug,
                                                    categoriesTree.source,
                                                )}
                                                className={styles.subcategoryLink}
                                            >
                                                {subcategoryTitle}
                                            </Link>
                                        </li>
                                    ),
                                )}
                            </ul>
                        </Accordion.Content>
                    )}
                </Accordion.Item>
            ))}
        </Accordion.Root>
    );
};
